import React from "react";
import "./CachacaMobile.css";
import logo from "../../../assets/cachaca/logo-cachaca.png";
import produto from "../../../assets/cachaca/produto.png";

export default function Cachaca() {
  return (
    <div className="container-cachaca-mobile">
      <div className="content-group-wrapper-cachaca-mobile">
        <div className="content-group-container-cachaca-mobile">
          <div className="logo-img-container-cachaca-mobile">
            <img src={logo} className="logo-img-cachaca-mobile"></img>
          </div>
        </div>
        <div className="content-group2-container-cachaca-mobile">
        <div className="about-cachaca-mobile">
         <div className="about-title-cointainer-cachaca-mobile"> 
        <p className="about-title-cachaca-mobile">TRADICIONAL BLEND EXCLUSIVO</p>
        </div>
        <div className="about-text-container-cachaca-mobile"> 
        <p className="about-text2-cachaca-mobile">Destilada artesanalmente usando nossa antiga receita,<br/> a Cachaça Tradicional Poços de Caldas entrega um<br/>  sabor aveludado, suave e equilibrado, seu aroma é <br/> refinado, com sutis traços de madeira.</p> 
        <p className="about-text2-cachaca-mobile">- Produzida 100% na região <text className="about-text-cachaca-mobile">mineira brasileira.</text></p>
        <p className="about-text2-cachaca-mobile">- A escolha certa do terreno, uma boa preparação do solo,<br/> uma coleta de cana selecionada, e um processo de alta<br/> qualidade, dão as características exclusivas de nosso<br/> produto.</p>
        <p className="about-text-cachaca-mobile">- Aroma refinado e adocicado <text className="about-text2-cachaca-mobile">que remete a madeira.</text></p>
        <p className="about-text2-cachaca-mobile">- Sabor rico, equilibrado, <text className="about-text-cachaca-mobile">suave e aveludado,</text><br/> com notas aromáticas de frutas secas.</p>
        </div> 
        <div className="line-container-cachaca-mobile"></div>
        <p className="about-text3-cachaca-mobile">750 ml | ALC 40% Vol.</p>  
        <div className="line-container-cachaca-mobile"></div>    
        </div>

        </div>
        <div className="content-group3-container-cachaca-mobile">
        <p className="title-cachaca-mobile">Presenteie <br/>Certo!</p>
        <div className="produto-nutricional-img-container-cachaca-mobile">
          
            <img src={produto} className="produto-nutricional-img-cachaca-mobile"/>
        </div>
        
        </div>
      </div>
    </div>
  );
}
